import { Divider } from 'components/Divider/Divider';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownHeaderTrigger } from 'components/Dropdown/HeaderTrigger/DropdownHeaderTrigger';
import { DropdownMenu } from 'components/Dropdown/menus/Menu/DropdownMenu';
import { DropdownMenuItem } from 'components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { Icon } from 'components/Icon/Icon';
import { Stack } from 'components/Stack/Stack';
import type { ListingType } from 'types/ListingType';
import type { OrgType } from 'utils/constants/general/orgTypes';

import { MarkAppliedMenuItem } from './MarkAppliedMenuItem';
import { ReportListingMenuItem } from './ReportListingMenuItem';
import { SaveOrgMenuItem } from './SaveOrgMenuItem';
import { ShareMenuItem } from './ShareMenuItem';

type Props = {
  hasAts?: boolean;
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  orgId?: string;
  orgName?: string;
  orgType?: OrgType;
};

export function ListingActionsDropdown({
  hasAts,
  listingId,
  listingType,
  listingUrl,
  orgId,
  orgType,
  orgName,
}: Props) {
  const showMarkApplied = listingType === 'JOB' && !hasAts;
  return (
    <Dropdown
      aria-label={getText('View more actions')}
      qaId="listings-more-actions"
      trigger={
        <DropdownHeaderTrigger
          qaId="listings-more-actions-toggle"
          variant="secondary"
        >
          <Icon name="3-dots" size={18} />
        </DropdownHeaderTrigger>
      }
    >
      <DropdownMenu width="180px" mobilePlacement="top-left">
        <Stack
          direction="column"
          divider={<Divider marginBottom={0} marginTop={0} />}
        >
          <DropdownMenuItem mobileOnly>
            <ShareMenuItem
              listingId={listingId}
              listingType={listingType}
              listingUrl={listingUrl}
              orgId={orgId}
            />
          </DropdownMenuItem>

          {showMarkApplied ? (
            <DropdownMenuItem>
              <MarkAppliedMenuItem
                listingId={listingId}
                listingType={listingType}
                orgId={orgId}
                orgType={orgType}
              />
            </DropdownMenuItem>
          ) : null}

          {orgId && orgName && orgType ? (
            <DropdownMenuItem>
              <SaveOrgMenuItem
                orgId={orgId}
                orgName={orgName}
                orgType={orgType}
              />
            </DropdownMenuItem>
          ) : null}

          <DropdownMenuItem>
            <ReportListingMenuItem
              listingId={listingId}
              listingType={listingType}
            />
          </DropdownMenuItem>
        </Stack>
      </DropdownMenu>
    </Dropdown>
  );
}
